import { render, staticRenderFns } from "./Panache.vue?vue&type=template&id=3f537f6e&scoped=true&"
import script from "./Panache.vue?vue&type=script&lang=js&"
export * from "./Panache.vue?vue&type=script&lang=js&"
import style0 from "./Panache.vue?vue&type=style&index=0&id=3f537f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f537f6e",
  null
  
)

export default component.exports